<nz-modal
  [nzMaskClosable]="false"
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="requestClose()"
  [nzWidth]="760"
>
  <ng-template #modalTitle>{{ title }}</ng-template>

  <ng-template #modalContent>
    <nz-spin [nzSpinning]="loading">
      <form nz-form nzLayout="horizontal" class="mail-form">
        <nz-form-item>
          <nz-form-label [nzSpan]="5">Empfänger</nz-form-label>
          <nz-form-control [nzSpan]="19">
            <input nz-input [value]="recipientLabel()" disabled />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="5">CC</nz-form-label>
          <nz-form-control [nzSpan]="19">
            <nz-select
              nzMode="tags"
              nzPlaceHolder="CC-Adressen"
            [(ngModel)]="cc"
            [ngModelOptions]="{standalone: true}"
            [nzTokenSeparators]="[',', ';']"
              (ngModelChange)="markDirty()"
            ></nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="5">Betreff</nz-form-label>
          <nz-form-control [nzSpan]="19">
            <input nz-input [value]="subject" disabled />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item class="mail-form__body">
          <nz-form-label [nzSpan]="5" nzRequired>Nachricht</nz-form-label>
          <nz-form-control [nzSpan]="19">
            <textarea nz-input rows="16" [(ngModel)]="body" [ngModelOptions]="{standalone: true}" (ngModelChange)="markDirty()"></textarea>
          </nz-form-control>
        </nz-form-item>
      </form>
      <div class="order-cap">
        Absender {{ fromEmail || '–' }} · Antwort an {{ replyTo || '–' }}
      </div>
    </nz-spin>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" type="button" [disabled]="sending" (click)="requestClose()">Abbrechen</button>
    <button
      nz-button
      nzType="primary"
      type="button"
      [nzLoading]="sending"
      [disabled]="loading || !body?.trim() || !toEmail"
      (click)="send()"
    >Senden</button>
  </ng-template>
</nz-modal>
